import { simpleFetch } from './customFetch';

export const getMyBoxRate = (options = {}) => simpleFetch(
  '/ratings/self',
  options,
  process.env.REACT_APP_QUESTIONNAIRE_API,
);
